














import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import links from '@/data/links'

const siteModule = namespace('site')

@Component
class LcNavBar extends Vue {
  @siteModule.Action('toggleDrawerDisplay') toggleDrawerDisplay: any

  links = links
}
export default LcNavBar
